import * as cssVariable from 'cssVariables';
import { breakpoints, mediaQuery } from 'components/theme/breakpoints';

export default {
  container: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    marginBottom: 25,
    paddingLeft: 40,
    height: 125,
    alignItems: 'center',
    position: 'relative',
    '& > *': {
      zIndex: '10',
    },
  },
  containerTouch: {
    marginTop: -30,
  },
  logo: {
    maxWidth: 130,
    marginRight: 40,
  },
  contentContainer: {
    width: 370,
    marginRight: 40,
    color: cssVariable.white,
  },
  title: {
    fontSize: cssVariable.fontSizes.medium,
    margin: 0,
  },
  content: {
    marginTop: 0,
  },

  buttonContainer: {
    display: 'flex',
    '& > button ': {
      marginRight: 10,
    },
  },
  imageContainer: {
    zIndex: '5',
  },
  image: {
    height: '100%',
    marginLeft: 'auto',
    position: 'absolute',
    zIndex: 5,
    right: 0,
    top: 0,
    maskImage: 'linear-gradient(to left, rgba(0,0,0,1), rgba(0,0,0,0))',
  },
  [mediaQuery.maxWidth(breakpoints.sl)]: {
    container: {
      height: 150,
      flexDirection: 'column',
      justifyContent: 'center',
      padding: [0, 10],
    },
    contentContainer: {
      width: '100%',
      maxWidth: 370,
      textAlign: 'center',
      marginRight: 0,
    },
    logo: {
      display: 'none',
    },
    image: {
      opacity: '0.5',
    },
  },
  minimalFavBtn: {
    background: 'none',
    border: 'none',
    color: cssVariable.white,
    padding: 0,
    width: 45,
    height: 40,
    '&:disabled': {
      opacity: 0,
      cursor: 'auto',
    },
  },
};
